// Footer on every page: the owner on the left, the build slug on the right.
import { buildSlug, COPYRIGHT } from "../lib/build";

export function Footer() {
  return (
    <footer className="footer">
      <span>{COPYRIGHT}</span>
      <span className="build">{buildSlug()}</span>
    </footer>
  );
}
